import Link from "next/link";
import React from "react";
import { useRouter } from "next/router";
import { WEB_URL } from "@/config/endpoints";


const ShimmerBar = () => {
  const router = useRouter();
  return (
   
      <div className="shimmer">
        <div className="container px-3 text-center text-sm py-[8px] sm:text-sm text-white">
          Apply for instant GST business loan <strong>up to INR 1 Cr</strong>{" "}
          <Link href={WEB_URL+`/business-loan`}>
            <button
              type="button"
              className="text-brand sm:mt-[5px] ml-1 px-1 sm:text-xs rounded-md py-[3px] text-sm bg-[#FECD2F]"
              onClick={() => {
                window.gtag('event', 'check_eligibility', {
                  'event_category': 'check_eligibility',
                  'event_label': 'Check Eligibility'
                  });
              }}
            >
              Apply Now
            </button>
          </Link>
        </div>
      </div>
    
  );
};

export default ShimmerBar;
